import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import React, { useEffect, useState } from "react";

const EditNodeModal = ({ open, onClose, selectedNode, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    role: "",
    job_function: "",
    job_family: "",
    department: "",
  });

  const [isCreatedNode, setIsCreatedNode] = useState(false);
  // const positionOptions = [
  //   ...new Set(orgData.map((node) => node.positionName)),
  // ];
  useEffect(() => {
    if (!selectedNode) {
      return;
    } else {
      selectedNode.hasOwnProperty("isCreated")
        ? setIsCreatedNode(selectedNode.isCreated)
        : setIsCreatedNode(false);
      console.log(selectedNode);
      const fullName = selectedNode.name?.split(", ") || [];
      console.log(fullName);
      setFormData({
        name: fullName[1] || "",
        surname: fullName[0] || "",
        role: selectedNode.role || "",
        job_function: selectedNode.job_function || "",
        job_family: selectedNode.job_family || "",
        department: selectedNode.department || "",
        isModified: true,
      });
      selectedNode.hasOwnProperty("isCreated")
        ? setIsCreatedNode(selectedNode.isCreated)
        : setIsCreatedNode(false);
    }
    //console.log(selectedNode);
  }, [selectedNode]);

  const handleChange = (e) => {
    console.log(e.target);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [errors, setErrors] = useState({});
  const handleSubmit = () => {
    const requiredFields = ["role"]; //, "job_family", "job_function", "department"
    const newErrors = {};
    requiredFields.forEach((field) => {
      //verifica che tutti i campi siano compilati
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "Required";
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const newFormData = {
      ...formData,
      name: `${formData.surname}, ${formData.name}`,
    };
    onSubmit(newFormData);
    setFormData({
      name: "",
      surname: "",
      role: "",
      job_function: "",
      job_family: "",
      department: "",
    });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "none",
          borderRadius: "1rem",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "24px" }} align="center">
        {I18n.get("Edit node")}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 5 }}>
          <TextField
            variant="standard"
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            disabled={!isCreatedNode}
            // error={Boolean(errors.name)}
            // helperText={errors.name}
          />
          <TextField
            variant="standard"
            label="Surname"
            name="surname"
            value={formData.surname}
            onChange={handleChange}
            disabled={!isCreatedNode}
            // required
            // error={Boolean(errors.job_family)}
            // helperText={errors.job_family}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 5 }}>
          <TextField
            variant="standard"
            label="Role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
            error={Boolean(errors.role)}
            helperText={errors.role}
          />
          <TextField
            variant="standard"
            label="Job family"
            name="job_family"
            value={formData.job_family}
            onChange={handleChange}
            // required
            // error={Boolean(errors.job_family)}
            // helperText={errors.job_family}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 5 }}>
          <TextField
            variant="standard"
            label="Job function"
            name="job_function"
            value={formData.job_function}
            onChange={handleChange}
            // required
            // error={Boolean(errors.job_function)}
            // helperText={errors.job_function}
          />

          <TextField
            variant="standard"
            label="Department"
            name="department"
            value={formData.department}
            onChange={handleChange}
            // required
            // error={Boolean(errors.department)}
            // helperText={errors.department}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Close")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: "rgb(52, 71, 103)",
            color: "rgb(255, 255, 255)",
            "&:hover": {
              backgroundColor: "rgb(40, 55, 80)",
            },
          }}
        >
          {I18n.get("Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditNodeModal;
